var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _path4, _rect5, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipmentStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 70 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8623 16.3344L20.5979 1.52979L37.3336 16.3344V50.1275H3.8623V16.3344Z",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0684 15.3686L20.4362 7.96631L28.804 15.3686V21.3226H12.0684V15.3686Z",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28711 18.862L20.5975 1.52979L39.9078 18.862",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.41406,
    y: 31.1392,
    width: 4.02299,
    height: 14.1609,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5859,
    y: 31.1392,
    width: 4.02299,
    height: 14.1609,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7588,
    y: 31.1392,
    width: 4.02299,
    height: 14.1609,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.333,
    y: 31.1392,
    width: 28.8046,
    height: 18.9885,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 50.1274H0",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5518,
    y: 38.2197,
    width: 8.36782,
    height: 11.908,
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.333 31.1392H68.7123L64.8503 23.4955H37.333V31.1392Z",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentStandard);
export default __webpack_public_path__ + "static/media/equipment_standard.fdaf27b323c0f5bddbf091ef04a22be9.svg";
export { ForwardRef as ReactComponent };